import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'enumKeyValuelist'
})

export class EnumKeyValueListPipe implements PipeTransform {
    transform(enumObj: any): any {
        return Object.keys(enumObj)
        .filter((key) => isNaN(Number(key))) // Exclude numeric keys (reverse mapping in numeric enums)
        .map((key) => ({ key: enumObj[key as keyof typeof enumObj] , value:key}));
    }
}